import React from "react";

const AdSec = () => (
  <div id="Ad" className="flex flex-col items-center justify-center text-center bg-white w-full h-screen py-10 px-4">
    <h1 className="text-5xl font-bold text-red-600 mb-4">Want to Get Your Company Seen?</h1>
    <p className="text-xl text-gray-800 mb-6">
      It is you that make such a idea posssible.. we care a lot about companies that come forward to advertise with us...
    </p>
    <p className="text-lg text-gray-600 mb-8">
        Why us you why ask..! we have the lowest cost in the industry as simple as that..
    </p>
    <a href="mailto:nrpartheevsai@gmail.com"><button className="bg-red-600 text-white py-2 px-6 rounded-lg text-xl font-semibold hover:bg-red-700 transition-all">
       Contact Us Now!!
    </button></a>
    
  </div>
);

export default AdSec;
